
import { useEffect, useState } from 'react';
import { GridPaginationModel } from '@mui/x-data-grid-pro';
import { FilterParam, GridMetaData, IColumnSetting, Sort } from 'models/grids';

const useGridMetadata = (filter: FilterParam, sort: Sort[], columnSettings?: IColumnSetting[], pagination?: GridPaginationModel) => {
    const [ value, setValue ] = useState<GridMetaData>({
        filterParam: filter,
        sort,
        page: (pagination?.page ?? 0) + 1,
        gridPreferences: columnSettings,
        pageSize: pagination?.pageSize ?? 100
    });

    useEffect(() => {
        setValue({
            sort,
            filterParam: filter,
            page: (pagination?.page ?? 0) + 1,
            pageSize: pagination?.pageSize ?? 100
        });
    }, [ filter, sort, pagination ]);

    return value;
};

export default useGridMetadata;